// One compatibility cycle per external outgoing call. This is not an audio quality detector.
export class ConnectAudioRecovery {
  constructor(phone, {delay=1800, gap=250, refreshDelay=250}={}) { this.phone=phone; this.delay=delay; this.gap=gap; this.refreshDelay=refreshDelay; this.job=null; }
  cancel() { const job=this.job; if(job){job.cancelled=true;clearTimeout(job.timer);job.wake?.();}this.job=null; }
  manualControl() { if(this.job&&!this.job.active)this.cancel(); }
  schedule(session,call,mode) {
    if(call.recoveryScheduled)return;
    call.recoveryScheduled=true;
    if(!['outgoing_no_rtp','outgoing_always','outgoing_refresh'].includes(mode)||call.direction!=='outgoing'||!/^\+?[0-9]{7,24}$/.test(call.dialed_number||''))return;
    this.cancel();
    const job={session,call,mode,cancelled:false,active:false};this.job=job;
    job.timer=setTimeout(()=>{job.promise=this.run(job);},mode==='outgoing_refresh'?this.refreshDelay:this.delay);
  }
  current(job) { return this.job===job&&!job.cancelled&&this.phone.session===job.session&&!job.call.cancelled; }
  async wait(job,ms) { await new Promise(resolve=>{job.wake=resolve;job.timer=setTimeout(resolve,ms);});job.wake=null;return this.current(job); }
  async run(job) {
    const p=this.phone,s=job.session,pc=s.sessionDescriptionHandler?.peerConnection;
    try {
      if(!this.current(job)||p.held||p.holdOperation)return;
      // Let the initial ACK/SDP transaction settle; never compete with another offer.
      for(let i=0;pc?.signalingState&&pc.signalingState!=='stable'&&i<8;i++)if(!await this.wait(job,250))return;
      if(!this.current(job)||p.held||p.holdOperation||!pc||pc.signalingState!=='stable'||pc.connectionState==='failed')return;
      if(job.mode==='outgoing_no_rtp') {
        if(!pc.getStats)return;
        let timeout;
        const stats=await Promise.race([pc.getStats(),new Promise(resolve=>{timeout=setTimeout(()=>resolve(null),1000);})]).finally(()=>clearTimeout(timeout));
        if(!stats||!this.current(job))return;
        let packets=0;stats.forEach(r=>{if(r.type==='inbound-rtp'&&(r.kind||r.mediaType)==='audio')packets+=Number(r.packetsReceived)||0;});
        if(packets>0){p.callEvent(s,'audio-recovery','Incoming audio packets detected; automatic recovery skipped');return;}
      }
      if(!this.current(job)||p.held||p.holdOperation)return;
      // A PIN prompt may establish the PBX leg before the outside destination.
      // Avoid renegotiating media while the agent's PIN tones are playing out.
      for(let i=0;p.dtmfBusy?.(s)&&i<40;i++)if(!await this.wait(job,250))return;
      if(!this.current(job)||p.held||p.holdOperation)return;
      if(p.dtmfBusy?.(s)){p.callEvent(s,'audio-recovery','Media refresh skipped during extended keypad input; manual audio controls remain available');return;}
      job.active=true;p.emit();
      if(job.mode==='outgoing_refresh'){
        p.callEvent(s,'audio-recovery','Refreshing the media description after establishment (Asterisk 21 compatibility; no hold)');
        await p.setHeld(false,{automaticRecovery:true,refresh:true});
        if(this.current(job))p.callEvent(s,'audio-recovery','Media refresh accepted; confirm two-way audio. No automatic hold fallback.');
        return;
      }
      p.callEvent(s,'audio-recovery','Restoring call audio: one automatic hold/resume cycle');
      await p.setHeld(true,{automaticRecovery:true});
      if(!await this.wait(job,this.gap))return;
      await p.setHeld(false,{automaticRecovery:true});
      if(this.current(job))p.callEvent(s,'audio-recovery','Audio recovery cycle completed; confirm two-way audio');
    } catch(error) {
      if(this.current(job)){const message='Automatic audio recovery stopped. '+(p.held?'Call remains on hold; click Resume. ':'' )+error.message;p.lastError=message;p.callEvent(s,'audio-recovery-error',message);p.error(message);}
    } finally { if(this.job===job){this.job=null;p.emit();} }
  }
  get active(){return !!this.job?.active;}
}
